jQuery(function($){
  
  
  if($('.seog-filter-tools .filter-mob-button').length > 0) {
    
    $('body').on('click', '.seog-filter-tools .filter-mob-button', function(e){
      e.preventDefault();
      $('.seog-filter-tools .filters').toggle();
    });
    
  }
  
  if($('.seog-collection-products').length > 0) {
    
    var w = $('.seog-collection-products'),
        pg = w.find('#product-grid'),
        fw = w.find('.seog-filter-tools'),
        ffw = fw.find('input:not([type="submit"]):not([type="button"]), select');
    
    
    if(ffw.length > 0) {
     
      ffw.on('change', function(e) { //trigger on change
        
        do_collection_filter();
        
//         $('html, body').animate({
//             scrollTop: pg.offset().top
//         }, 1000);
        
      });
      
      
      do_collection_filter(); //trigger on first load
      
      //trigger
      function do_collection_filter() {
        
        var products = pg.attr('data-products') ? $.parseJSON(pg.attr('data-products')) : {},
            tags_field = ['type','features','max_hopper','max_speed','currency'];
        
        pg.find('.grid__item').hide(); //show all first
        
        $.map(ffw, function(item, index) {
          
          var field = $(item),
              value = field.val(),
              name = field.attr('name');
          
          
          if(name == 'prices') { //prices field
            
            var prices = value.split(';');
            
            if(prices) {
              
              products = $.grep(products, function (n, i) {


                          var price = n.price,
                              minPrice = parseFloat((prices[0] * 1).toFixed(2)),
                              maxPrice = parseFloat((prices[1] * 1).toFixed(2));

                          if (typeof price == 'string') { //convert
                            price = price.replace('.',''); 
                          }

                          if (isNaN(price) || price == null) { return false; }

                          price = (price/100.0).toFixed(2);
                		  price = parseFloat(price);
                
                
//                             console.log(minPrice);
//                             console.log(price);
//                             console.log(maxPrice);
                			
                          if(minPrice <= price && maxPrice >= price) {
							return true;
                          }else{
                            return false;
                          }
                
                
                      }); //end filter or grep
              
            }
            
          } //end prices
          
//           console.log(tags_field);
          //for tags
          if(jQuery.inArray(name, tags_field) !== -1 && field.is(":checked") && value != '') {

              products = $.grep(products, function (n, i) {

                if(jQuery.inArray(value, n.tags) !== -1) {
                  return true; 
                }else{
                  return false;
                }

              }); //end filter or grep

          } //end tags
          
          
          
        }); //end mapping of fields
        
        
        //filter products
        var _check_visible = 0;
        $.map(products, function(product, index) {
          pg.find('.grid__item[data-product_id="'+product.id+'"]').show();
          _check_visible++;
        });
        
        pg.next('.no-results').remove();
        if(_check_visible === 0) {
          pg.after('<div class="no-results">No results was found!</div>');
        }
        
        
      }
      
    }
    	
    
  }
  
  
});